import { useTranslation } from 'react-i18next';
import recruitBanner from '@/assets/imgs/recruit/banner.png';
import './RecruitHero.css';

export function RecruitHero() {
  const { t } = useTranslation();

  return (
    <section className="recruit-hero">
      <div className="recruit-hero__visual">
        <img src={recruitBanner} alt="" />
        <div className="recruit-hero__overlay" />
        <h1>{t('recruit.hero.title')}</h1>
      </div>
    </section>
  );
}
